export const registerBreadcrumbs = manager => {
  const vue = manager;

  manager.register("home", tail => tail.push(vue.$t("home"), vue.$localize({ name: "main" })));
  manager.register("simple-page-item", (tail, { title }) => tail.parent("home").push(title));
  manager.register("page", (tail, { page }) =>
    tail.parent("home").push(page.title, vue.$localize({ name: "page", params: { slug: page.slug } }))
  );
  manager.register("page-for-type", (tail, { page, type }) => {
    let navigationItem = manager.resolveNavigationItemForPage(vue.$route.params.slugPage);
    if (type === "new") {
      /*todo - use `configType` to search instead of `slug`*/
      navigationItem = manager.resolveNavigationItemForPage("scientific-news");
    }

    tail.parent("page", { page: navigationItem }).push(page.title);
  });

  manager.register("news", tail => tail.parent("home").push("Блог", vue.$localize({ name: "news" })));
  manager.register("news-single", (tail, { page }) => tail.parent("news").push(page.title));
  manager.register("author", (tail, { author }) => tail.parent("news").push(author.name));

  manager.register("sub-page", (tail, { page, subPageItem }) => tail.parent("page", { page }).push(subPageItem.title));

  manager.register("buy-flow-basket", tail =>
    tail.parent("home").push(vue.$t("basket"), vue.$localize({ name: "buy-flow-basket" }))
  );
  manager.register("buy-flow-order", tail => tail.parent("buy-flow-basket").push(vue.$t("completeOrder")));

  manager.register("catalog", tail => tail.parent("home").push(vue.$t("catalog"), vue.$localize({ name: "products" })));
  manager.register("promotions", tail =>
    tail.parent("home").push("Унікальні пропозиції", vue.$localize({ name: "promotions" }))
  );
  manager.register("products", tail => tail.parent("catalog").push(vue.$t("products")));
  manager.register("product-card", (tail, { product }) => {
    tail
      .parent("catalog")
      .when(!!product.brand, tail => {
        tail.push(
          product.brand.title,
          vue.$localize({
            name: "brand",
            params: { slug: product.brand.slug || product.brand.name },
          })
        );
      })
      .when(!!product.brandSeries, tail => {
        // Серія тепер фільтр: лінк веде на бренд (або каталог) із ?series=<slug>.
        const seriesSlug = product.brandSeries.slug || product.brandSeries.name;
        const brandSlug = product.brand && (product.brand.slug || product.brand.name);
        tail.push(
          product.brandSeries.title,
          brandSlug
            ? vue.$localize({ name: "brand", params: { slug: brandSlug }, query: { series: seriesSlug } })
            : vue.$localize({ name: "products", query: { series: seriesSlug } })
        );
      })
      .push(product.title);
  });

  manager.register("profile", tail => tail.parent("home").push(vue.$t("profile"), vue.$localize({ name: "profile" })));

  manager.register("brand", (tail, { hero } = {}) => {
    tail.parent("catalog");
    if (hero && (hero.title || hero.metaTitle)) {
      tail.push(hero.title || hero.metaTitle);
    }
  });

  manager.register("collection", (tail, { hero } = {}) => {
    tail.parent("catalog");
    if (hero && (hero.title || hero.metaTitle)) {
      tail.push(hero.title || hero.metaTitle);
    }
  });

  manager.register("outlet", (tail, { hero } = {}) => {
    tail.parent("catalog");
    if (hero && (hero.title || hero.metaTitle)) {
      tail.push(hero.title || hero.metaTitle);
    }
  });

};
